import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes.js'
import { useCookies } from "vue3-cookies";
import axios from 'axios';

const { cookies } = useCookies();
import store from '../store';

const router = createRouter({
	// 4. Provide the history implementation to use. We are using the hash history for simplicity here.
	history: createWebHistory(),
	routes, // short for `routes: routes`
	linkActiveClass: "active",
	linkExactActiveClass: "active",
})

const comprobarRoles = (rolesRoutes, rolesState) => {
	let result = false;
	if(rolesRoutes){
		for (let i = 0; i < rolesRoutes.length; i++) {
			const rol = rolesRoutes[i];
			if(rolesState[rol] && rolesState[rol] == true){
				result = true;
				break;
			}
		}
	}
	return result;
}

router.beforeEach((to, from, next) => {
	//Persolanizar según el control de sesion y roles de cada proyecto
	if (to.matched[0].meta.requiresAuth) {
		if (!cookies.isKey('token')) {
			if (cookies.isKey('refreshToken')) {
				axios.post('/user/refreshToken', { username: cookies.get('username'), userType: "BACKOFFICE", refreshToken: cookies.get('refreshToken') })
					.then((response) => {
						cookies.set('token', response.data.credentials.accessToken, response.data.credentials.expiresIn + 's');
					})
					.catch(() => {
						next({
							name: 'login',
							params: { nextUrl: to.fullPath }
						})
					});
			} else {
				next({
					name: 'login',
					params: { nextUrl: to.fullPath }
				})
			}
		}
		else {
			if (comprobarRoles(to.meta.roles,store.state.roles)) {
				next()
			} else {
				next({
					name: 'page-unauthorized'
				})
			}
		}
	}
	else {
		next();
	}
})

export default router